export enum AVAILABLE_MODEL_DISPLAY_TYPE {
    // doesn't use the custom meu if present, just puts all the items in a flat menu
    ONLY_DISPLAY_MODELS = 'OnlyDisplayModels',
    // hides the listed model in the custom menu and items with sublists no items
    HIDE_MODELS_IN_CUSTOM_MENU = 'HideModelsInCustomMenu',
    // shows the listed model in the custom menu and items with sublists no items
    SHOW_MODELS_IN_CUSTOM_MENU = 'ShowModelsInCustomMenu',
}
